// extracted by mini-css-extract-plugin
export default {"row":"supplier-purchase-kanban_row__i+EZv","head":"supplier-purchase-kanban_head__hT1+9"};